import { isDefined } from '@sgme/fp';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';

import {
  useCheckTargetAccumulatorByTradeCapture,
  useTargetAccumulatorTileId,
} from '@/App/tiles/TargetAccumulator/TargetAccumulatorContext.tsx';
import { DatePickerWithTenorNext } from '@/components/ui/DatePickerWithTenorNext.tsx';
import { TradeCaptureValidationWrapper } from '@/components/ui/TradeCaptureFieldErrorWrapper.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import {
  selectTargetAccumulatorScheduleData,
  selectTargetAccumulatorScheduleFieldValidation,
  selectTargetAccumulatorScheduleTable,
} from '@/store/targetAccumulator/selectors.ts';
import type { AccumulatorScheduleLine } from '@/store/targetAccumulator/state.ts';

const FixingDate = ({ legId }: { legId: string }) => {
  const tileId = useTargetAccumulatorTileId();
  const fixingDate = useAppSelector((state) => selectTargetAccumulatorScheduleTable(state, tileId, legId)?.fixingDate);
  const isModified = useAppSelector(
    (state) =>
      selectTargetAccumulatorScheduleData(state, tileId).scheduleCustomFields?.[legId]?.includes('FixingDate') ?? false,
  );
  const checkTargetAccumulatorWithTradeCapture = useCheckTargetAccumulatorByTradeCapture();
  const { sgwtWebAnalytics } = useSgwtWidgets();
  const { validation } = useAppSelector((state) =>
    selectTargetAccumulatorScheduleFieldValidation(state, tileId, legId, 'fixingDateString'),
  );

  const handleFixingDate = (value: string) => {
    sgwtWebAnalytics?.trackEvent('Target Accumulator', 'Schedule fixing date changed', value ?? 'null');

    return checkTargetAccumulatorWithTradeCapture({
      schedule: { [legId]: { fixingDate: isDefined(value) ? value : null } as AccumulatorScheduleLine },
    });
  };

  return (
    <div style={{ maxWidth: '8rem' }}>
      <TradeCaptureValidationWrapper validation={validation}>
        <DatePickerWithTenorNext
          color={isModified ? 'info' : undefined}
          date={isDefined(fixingDate) ? fixingDate : undefined}
          onChange={handleFixingDate}
          allTenors={[]}
          data-e2e="fixingDate"
        />
      </TradeCaptureValidationWrapper>
    </div>
  );
};

export default FixingDate;
